
import { Message } from 'tplus-components-touch';
import {PosInitData} from 'tplus-poslogin'
/**判断会员是否启用 */
import {IsMemberEnableProcessor} from '../../member/IsMemberEnableProcessor'
/**判断会员是否生效 */
import {IsMemberEffectiveProcessor} from '../../member/IsMemberEffectiveProcessor'
/**判断会员是否失效 */
import {IsMemberExpirationProcessor} from '../../member/IsMemberExpirationProcessor'
/**依据门店判断会员是否储值 */
import {IsMemberStorageForStoreProcessor} from '../../member/IsMemberStorageForStoreProcessor'
/**
 * 储值时校验
 */

export class CheckMemberStorageProcessorBlock
{
    static execute(memberDto)
    {
        if(!IsMemberStorageForStoreProcessor.execute()){
            return '门店类型为专柜的，不能进行该操作!';
        }
        if (!memberDto.MemberType.IsStorage) {
            return '该会员的会员类型没有储值属性，不能进行该操作!';
        }
        // 判断会员是否启用
        if (!IsMemberEnableProcessor.execute(memberDto)) {
            return '当前会员未启用，不能进行该操作!';
        }
        // 判断会员是否生效
        if (!IsMemberEffectiveProcessor.execute(memberDto)) {
            return '当前会员未生效，不能进行该操作!';
        }
        // 判断会员是否失效
        if (!IsMemberExpirationProcessor.execute(memberDto)) {
            return '当前会员已失效，不能进行该操作!';
        }
        //如果门店不是总部，且会员管理方式为总部统一管理的时候，则不让储值
        const isHeaderQuaters =PosInitData('IsHeaderQuaters');
        const memberManagementMode =PosInitData('MemberManagementMode');
        if(!isHeaderQuaters&&memberManagementMode=='0')
        {
            return `当前门店为加盟店，不能对总部统一管理的会员进行储值!`;
        }
        return '';
    }
}

global.CheckMemberStorageProcessorBlock=CheckMemberStorageProcessorBlock;
